// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z_82","field":"styles_field__1evbs","fieldCol":"styles_fieldCol__2bmrf","diffCol":"styles_diffCol__1p7jq","diff":"styles_diff__cK2Gr"};